export default "__VITE_ASSET__28bdd097__"